var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('UiDialog', {
    ref: "uiFilterListMobileModal",
    attrs: {
      "width": "500px",
      "title": "Фильтр",
      "without-footer": "",
      "without-scroll": ""
    }
  }, [_c('UiFilterList', {
    attrs: {
      "filters": _vm.filters,
      "initialFilters": _vm.initialFilters,
      "mobile": ""
    },
    on: {
      "changeMobile": function (e) {
        return _vm.changeMobile(e);
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }